import { usePartDefinition } from "@project/emerge";
import type { VolumeDefinition } from "../interfaces/VolumeProperties";
import { PartEdges } from "./PartEdges";

export const VolumeRenderer = ({ id }: { id: string }) => {
  // Nur die Eigenschaften abonnieren, die für das Rendering benötigt werden
  const partDef = usePartDefinition<VolumeDefinition>({
    id,
    select: ["size"],
  });

  if (!partDef) return null;

  const { size } = partDef;

  const width = size?.[0] || 1;
  const height = size?.[1] || 1;
  const depth = size?.[2] || 1;

  return (
    <group>
      {/* Main volume */}
      {/* Der Innenraum ist eine Sichthilfe, kein verbautes Teil: er darf auch
          dann keine Zeiger-Events abfangen, wenn ein Host ihn einblendet. Seine
          Flächen liegen im Plattenmaterial, also läge er sonst vor jedem in
          eine Ausfräsung eingelassenen Teil (z. B. einem Butterfly-Schloss). */}
      <mesh raycast={() => null}>
        <boxGeometry args={[width, height, depth]} />
        <meshStandardMaterial color="#99ccff" transparent opacity={0.7} />
        <PartEdges />
      </mesh>
    </group>
  );
};
